@if (!(linkedPlayers?.length > 0)) {
  <div class="p-2">
    <app-info-text text="LINKED_PLAYERS_PLAYER_PROFILE_MSG" color="text-gray-400"/>
  </div>
}
<div class="flex align-items-center gap-2">
  <p-button [label]="('LINK_PLAYER' | translate) + '...'"
            styleClass="p-button-text" icon="pi pi-plus" (click)="linkAccount()"/>

  <p-button [label]="('MY_LEAGUES' | translate)"
            [disabled]="(linkedPlayers?.length > 0)"
            styleClass="p-button-text" routerLink="/frontend/player/profile/dashboard/my-leagues"/>
</div>

<p-divider/>

<app-loading [active]="isLoading"/>
<app-message [active]="!!errorMsg" [message]="errorMsg"/>

@if (!isLoading) {
  @if (linkedPlayers?.length > 0) {
    <app-generic-list class="frontend smart" [frontend]="true"
                      [data]="linkedPlayers"
                      [columns]="columns" [columnsMobile]="columnsMobile"
                      [scrollable]="false" [selectionMode]="undefined"
                      [mobileRowTemplate]="mobileRowTemplate"
                      [rowEdit]="false"
                      [dataLoading]="listLoading"
                      [rowDelete]="true" (onRowDelete)="deleteLinkedPlayer($event)"
                      [sortable]="true" [sortOrder]="1" [sortField]="'playerName'"
    />
  } @else {
    <p>
      {{ 'NO_PLAYER_LINKS_YET' | translate }}
    </p>
  }
}

<ng-template #mobileRowTemplate let-item="data" pTemplate="item">
  <td>
    <div>
      {{item.playerName}}
    </div>
    <div class="flex align-items-center gap-2 text-gray-400">
      <div class="flex-1">
        {{item.mandantName}}
      </div>
      <div>
        {{'MEMBER_NR' | translate}}:&nbsp;{{item.passNr}}
      </div>
    </div>
  </td>
</ng-template>
